import * as React from 'react';

import { cn } from '@/lib/utils';

/*
 * shadcn input, restyled to the prototype's sunken bevel well: inset border,
 * mono text, zero radius, real focus-visible ring (the mock had none).
 */
function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'bevel-in bg-bar-bg text-text placeholder:text-faint font-mono text-sm',
        'flex h-9 w-full min-w-0 px-3 py-1 outline-none transition-[color]',
        'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:ring-2 aria-invalid:ring-destructive',
        'file:text-text file:border-0 file:bg-transparent file:text-sm',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
